module.exports = __webpack_public_path__ + "static/media/profilepic.813c8b8e.jpg";